import React from 'react';
import ListOfBooks from './listOfBooks';

const BookContainer = () => (
  <div className="books-container">
    <ListOfBooks />
  </div>
);
export default BookContainer;
